"use client";

import { useState } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { Text } from "@/src/components/ui/Typography";
import type { Post } from "@/src/lib/blog/posts";
import { BlogPostCard } from "./BlogPostCard";

const PAGE_SIZE = 6;

interface CardListProps {
  posts: Post[];
}

export function CardList({ posts }: CardListProps) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = posts.slice(0, visible);
  const hasMore = posts.length > visible;

  if (posts.length === 0) {
    return (
      <Section className="bg-white">
        <Container>
          <Text size="bodyMD" className="text-center text-neutral-500">
            We&rsquo;re writing our first post. Check back soon.
          </Text>
        </Container>
      </Section>
    );
  }

  return (
    <Section className="bg-white !pt-0">
      <Container>
        <div className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((post, i) => (
            <BlogPostCard key={post.slug} post={post} priority={i < 3} />
          ))}
        </div>

        {hasMore && (
          <div className="mt-14 text-center">
            <Button
              type="button"
              variant="secondary"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="border border-neutral-700"
            >
              Load more
            </Button>
          </div>
        )}
      </Container>
    </Section>
  );
}
